import GenericService from "./GenericService";

export default class NotaEmpenhoService extends GenericService{

    constructor(){
        super('/api/notas-empenho')
    }

    async obterEmpenhosComPagamentos( processo, contrato ){
        return await super.get(`?processo=${processo}&contrato=${contrato}&fetch-pagamentos=true`)
    }
}